// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const ArtifactTypeSchema = z.enum(['UNKNOWN','HTTP','PYTHON','CLI','BROWSER','TEXT'] as const);

export type ArtifactTypeType = `${z.infer<typeof ArtifactTypeSchema>}`

export default ArtifactTypeSchema;
